module.exports = __webpack_public_path__ + "assets/img/newsIcon1.1ff67835.png";